import type {TriggerIntegrationStruct} from '@cohort/shared/schema/apps/app';
import {Apps} from '@cohort/wallet/apps';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';
import {useCallback} from 'react';

export type Output<T extends TriggerIntegrationStruct> = {
  getTriggerIntegration: (triggerIntegrationId: T['Id']) => TriggerIntegration<T>;
};

export const useTriggerIntegrations = <T extends TriggerIntegrationStruct>(): Output<T> => {
  const getTriggerIntegration = useCallback(
    (triggerIntegrationId: T['Id']): TriggerIntegration<T> => {
      const appId = triggerIntegrationId.split('.')[0];
      const app = Apps.find(app => app.spec.id === appId);
      if (!app) {
        throw new Error(`No App found for id: ${appId}`);
      }
      const triggerIntegration = app.triggerIntegrations.find(
        integration => integration.spec.id === triggerIntegrationId
      );
      if (!triggerIntegration) {
        throw new Error(
          `No TriggerIntegration found for triggerIntegrationId: ${triggerIntegrationId}`
        );
      }
      return triggerIntegration as unknown as TriggerIntegration<T>;
    },
    []
  );

  return {
    getTriggerIntegration,
  };
};
